import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Box, ButtonAnimated, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import CommonModal from '../CommonModal/CommonModal';
import CompareSection from './CompareSection';
import TrimPanel from './TrimPanel';
import themeStyles from './PaymentCompareModal.styles';
import usePaymentCompareModal from '../PaymentCalculator/usePaymentCompareModal';
import useScreenSize from '../../utils/hooks/useScreenSize';
const ContentWrapper = themeStyles.apply(Box, 'ContentWrapper');
const SectionWrapper = themeStyles.apply(Box, 'SectionWrapper');
const BtnWrapper = themeStyles.apply(Box, 'BtnWrapper');
const PaymentCompareModal = () => {
    const { t } = useTranslation();
    const { isLarge, isExtraLarge, isSmall } = useScreenSize();
    const { allowThirdCalculator, submitModalForm, isModalOpen, addCalculator, visibleCalculators, closeModal } = usePaymentCompareModal();
    const [selectedCalculatorId, setSelectedCalculatorId] = useState(visibleCalculators[0]);
    const handleSubmitModalForm = () => {
        setSelectedCalculatorId(visibleCalculators[0]);
        submitModalForm(selectedCalculatorId);
    };
    const modalWidth = (isExtraLarge && '1200px') || (isLarge && '854px') || '100vw';
    // If the user opens the Compare Modal on a phone in landscape mode and then rotates the device to portrait mode,
    // the modal should close, and no changes should be applied
    useEffect(() => {
        if (isSmall) {
            closeModal();
        }
    }, [isSmall]);
    return (_jsx(Box, { "data-testid": "cy-payment-compare-modal", position: "relative", children: _jsxs(CommonModal, { handleCloseModal: handleSubmitModalForm, handleSubmit: handleSubmitModalForm, showModal: isModalOpen, title: t('Pages.Bap.comparePaymentsLabel'), width: modalWidth, styling: isLarge || isExtraLarge ? 'iframe' : 'fullOverlay', children: [_jsxs(ContentWrapper, { "data-body-scroll-lock-ignore": true, "data-testid": "cy-payment-compare-wrapper", children: [_jsx(TrimPanel, {}), _jsx(SectionWrapper, { "data-testid": "cy-payment-compare-modal-section", children: visibleCalculators.map(id => (_jsx(CompareSection, { id: id, isSelected: selectedCalculatorId === id, onSelect: () => setSelectedCalculatorId(id) }, id))) })] }), _jsx(Optional, { when: allowThirdCalculator && visibleCalculators.length < 3, children: _jsx(BtnWrapper, { "data-testid": "cy-payment-compare-modal-add-btn", children: _jsx(ButtonAnimated, { label: t('Pages.Bap.addPaymentButton'), onClick: () => {
                                addCalculator(selectedCalculatorId);
                            } }) }) })] }) }));
};
export default PaymentCompareModal;
